import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { b as bankAccountTypeOptions } from './business-form-options.js';
import './event-types.js';
import { n as numberOnlyHandler } from './utils3.js';
import { d as defineCustomElement$4 } from './custom-popper2.js';
import { d as defineCustomElement$3 } from './form-control-select2.js';
import { d as defineCustomElement$2 } from './form-control-text2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const BankAccountFormInputs = /*@__PURE__*/ proxyCustomElement(class BankAccountFormInputs extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
    }
    render() {
        return (h("div", { key: 'b18e803521d67b40e4e5af03a66dcdca0b678968', class: "row gy-3" }, h("div", { key: 'e2e6667ffbcebb6a9aa50739814e7bbebceaabfa', class: "col-12" }, h("form-control-text", { key: 'e1ad63fb7db32dbb6ed67cf18919c681d6d192ef', name: "bank_name", label: "Bank Name", defaultValue: this.defaultValue.bank_name, errorText: this.errors.bank_name, inputHandler: this.inputHandler, disabled: this.formDisabled })), h("div", { key: '54db821813e7eb931b8f19fad7fce976cdeb0045', class: "col-12" }, h("form-control-text", { key: '4ecf222c1918e364f319d07e0a770d68dba099d0', name: "nickname", label: "Nickname", defaultValue: this.defaultValue.nickname, errorText: this.errors.nickname, inputHandler: this.inputHandler, disabled: this.formDisabled })), h("div", { key: 'a92c38f2abbcb3dcaee4bc5ea73df44b31adc3f9', class: "col-12" }, h("form-control-text", { key: '492ff1a4d1e9c4f2fa9d0e527a34dc5ccb09afe6', name: "account_owner_name", label: "Account Owner Name", defaultValue: this.defaultValue.account_owner_name, errorText: this.errors.account_owner_name, inputHandler: this.inputHandler, disabled: this.formDisabled })), h("div", { key: '8e14e6e3de43822d139085d3a05bfd0e7ae5b1be', class: "col-12" }, h("form-control-select", { key: 'f6648b6f7c4a475f88b849bf3a75d446bb539c69', name: "account_type", label: "Account Type", options: bankAccountTypeOptions, defaultValue: this.defaultValue.account_type, errorText: this.errors.account_type, inputHandler: this.inputHandler, disabled: this.formDisabled })), h("div", { key: '68a2efc082f5b6414ebde10b6da4365677dbefca', class: "col-12" }, h("form-control-text", { key: '3ef9b3db5882063708ccf1eb282f3e90ed53ce82', name: "account_number", label: "Account Number", defaultValue: this.defaultValue.account_number, maxLength: 17, errorText: this.errors.account_number, inputHandler: this.inputHandler, keyDownHandler: numberOnlyHandler, disabled: this.formDisabled, helpText: "Please copy the account number as shown on your statement/check. Do not include spaces or dashes." })), h("div", { key: 'e3270db28269bc25dd4d5a99274f042c1efd1fc6', class: "col-12" }, h("form-control-text", { key: 'a8e801f65a4cc164cdc7bf186fed67f87abc828f', name: "routing_number", label: "Routing Number", defaultValue: this.defaultValue.routing_number, maxLength: 9, errorText: this.errors.routing_number, inputHandler: this.inputHandler, keyDownHandler: numberOnlyHandler, disabled: this.formDisabled, helpText: "A valid routing number is nine digits. Please include any leading or trailing zeroes." }))));
    }
}, [0, "bank-account-form-inputs", {
        "defaultValue": [8, "default-value"],
        "errors": [8],
        "inputHandler": [16, "input-handler"],
        "formDisabled": [4, "form-disabled"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bank-account-form-inputs", "custom-popper", "form-control-select", "form-control-text", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "bank-account-form-inputs":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BankAccountFormInputs);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { BankAccountFormInputs as B, defineCustomElement as d };
